module.exports = __webpack_public_path__ + "img/930.62454cbf.gif";